var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-search-browse",
    {
      ref: "browse",
      attrs: {
        "data-source": _vm.dataSource,
        "clear-view-settings-filters": _vm.clearViewSettingsFilters,
        "allow-view-button": _vm.allowViewButton,
        "override-static-view-select": _vm.overrideStaticViewSelect,
        "show-selected-items-count": _vm.multiple,
        view: _vm.view,
        multiple: _vm.multiple,
      },
      on: {
        multiple: function ($event) {
          return _vm.onMultiple()
        },
        click: function ($event) {
          return _vm.onClick($event)
        },
        "select-changed": function ($event) {
          return _vm.onSelectChanged($event)
        },
      },
    },
    [
      _vm._t("extra-buttons", null, { slot: "extra-buttons" }),
      _vm._t(
        "browse-action-buttons",
        function () {
          return [
            _vm.multiple
              ? _c(
                  "div",
                  [
                    _c(
                      "w-button",
                      {
                        staticClass: "ml",
                        attrs: { icon: "check", disabled: _vm.buttonDisabled },
                        on: {
                          click: function ($event) {
                            return _vm.onMultiple($event)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("common.confirm")) + " ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.bookYearSelect
              ? _c(
                  "div",
                  { staticClass: "bookyear-wrapper" },
                  [
                    _c("app-select-book-year", {
                      attrs: {
                        value: _vm.selectedBookYear,
                        "include-book-year0": "",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onBookYearChange($event)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        { slot: "browse-action-buttons" }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }